import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { get, set } from '@totalsoft/change-tracking-react';
import { isValid, getErrors } from '@totalsoft/pure-validations-react';
import { Grid } from '@mui/material';
import { Autocomplete, TextField, Card } from '@totalsoft/rocket-ui';
import { DateTime } from '@ts-private/rocket-extensions';

export const OutOfOfficeItemComponent = ({ validationInfo, itemLens, replacements }) => {
  const { t } = useTranslation();

  return (
    <Card>
      <Grid item container spacing={1}>
        <Grid item xs={12} sm={6} md={3}>
          <DateTime
            fullWidth
            value={itemLens.fromDate |> get}
            label={t('User.OutOfOffice.FromDate')}
            onChange={itemLens.fromDate |> set}
            timeFormat={false}
            disabled={false}
            error={!isValid(validationInfo.fromDate)}
            helperText={getErrors(validationInfo.fromDate)}
            required
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <DateTime
            fullWidth
            value={itemLens.toDate |> get}
            label={t('User.OutOfOffice.ToDate')}
            onChange={itemLens.toDate |> set}
            timeFormat={false}
            disabled={false}
            error={!isValid(validationInfo.toDate)}
            helperText={getErrors(validationInfo.toDate)}
            required
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <Autocomplete
            fullWidth
            value={itemLens.replacementUserId |> get}
            onChange={itemLens.replacementUserId |> set}
            label={t('User.OutOfOffice.Replacement')}
            valueKey='id'
            name='name'
            simpleValue={true}
            options={replacements}
            disabled={false}
            error={!isValid(validationInfo.replacementUserId)}
            helperText={getErrors(validationInfo.replacementUserId)}
            inputProps={{ required: true }}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            label={t('User.OutOfOffice.Comments')}
            fullWidth
            value={(itemLens.comments |> get) || ''}
            onChange={itemLens.comments |> set}
            disabled={false}
            simpleValue
          />
        </Grid>
      </Grid>
    </Card>
  );
};
OutOfOfficeItemComponent.propTypes = {
  validationInfo: PropTypes.object.isRequired,
  itemLens: PropTypes.object.isRequired,
  replacements: PropTypes.array
};

export default OutOfOfficeItemComponent;
